module.exports = __webpack_public_path__ + "static/presidents-message-social-banners-1200x630-73023b38ff830975fafa1872d2ca0eac.jpg";